import Layout from '../components/layout'
import ForgotForm from "../components/pages/forgot/forgotForm";

function Login() {
    return (
        <Layout>
            <div className="main-contact-container">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="cont-detail">
                                <div className="heading-bg">
                                    <h2>Which can we help you recover?</h2>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="forgotpass">
                                <ForgotForm/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Login;
